const docTemplates = {
  searchTemplates: "Search templates...",
  newTemplate: "New Template",
  noTemplates: "No templates",
  createFirst: "Create first template",
  untitledTemplate: "Untitled Template",
  total: "Total",
  backToPipeline: "Back to pipeline",
  backToTemplates: "Back to templates",
  templateNotFound: "Template not found",
  allStatuses: "All statuses",
  statusDraft: "Draft",
  statusActive: "Active",
  statusArchived: "Archived",
  duplicate: "Duplicate",
  archive: "Archive",
  copy: "copy",
  addDescription: "Add description...",
  addTag: "Tag...",
  saveVersion: "Save version",
  manageTemplates: "Manage Templates",
  useTemplate: "From Template",
  selectTemplate: "Select Template",
  blankDocument: "Blank Document",
  orBlank: "or create blank document",
  startFromScratch: "Start from scratch without a template",
} as const;
export default docTemplates;
